webpackJsonp([62,63,73],{

/***/ "0Ajs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var _default = {
	container: {
		width: '100%',
		padding: '1.28em 0',
		minHeight: '14.43em',
		margin: '0 0 2em'
	},
	inner: {
		padding: '0 1.06em'
	},
	poolName: {
		fontWeight: '600',
		fontSize: '1em'
	},
	tableBodyText: {
		fontSize: '1em'
	},
	statsContainer: {
		display: 'flex',
		flexFlow: 'row wrap',
		justifyContent: 'space-between',
		margin: '0 auto'
	}
};
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/WMCompanyPageTalentPools/styles/index.js');
}();

;

/***/ }),

/***/ "1MJl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _styles = __webpack_require__("kSyU");

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var colors = _styles2.default.colors;
var _default = {
	colors: colors,
	body: {
		fontFamily: 'Open Sans',
		width: '90%',
		display: 'flex',
		flexDirection: 'column',
		margin: '40px auto 0',
		fontSize: '14px',

		'@media screen and (max-width: 768px)': {
			fontSize: '12px'
		},

		'@media screen and (max-width: 550px)': {
			fontSize: '10px'
		}
	},
	pageTitle: function pageTitle(isLoading) {
		return {
			fontSize: '2.42em',
			textAlign: isLoading ? 'center' : 'left'
		};
	},
	loader: {
		margin: '0 auto',
		display: 'block'
	}
};
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(colors, 'colors', 'src/components/WMCompanyPage/styles/index.js');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/WMCompanyPage/styles/index.js');
}();

;

/***/ }),

/***/ "2ODj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.initialCompanyProfileState = undefined;

var _immutable = __webpack_require__("BYKG");

var _immutable2 = _interopRequireDefault(_immutable);

var _CompanyOverview = __webpack_require__("MTq+");

var _CompanyOverview2 = _interopRequireDefault(_CompanyOverview);

var _actionTypes = __webpack_require__("ocry");

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialCompanyProfileState = new _CompanyOverview2.default({});

var companyProfile = function companyProfile() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialCompanyProfileState;
	var _ref = arguments[1];
	var type = _ref.type,
	    value = _ref.value;

	switch (type) {
		case types.RECEIVE_COMPANY_INFO:
			if (!value) {
				return state;
			}
			return new _CompanyOverview2.default(_immutable2.default.fromJS(value));
		case types.TOGGLE_FOLLOW_COMPANY:
			return state.update('followedByUser', function (f) {
				return !f;
			}).set('followedByUserRequested', false);
		case types.TOGGLE_FOLLOW_COMPANY_REQUEST:
			return state.set('followedByUserRequested', true).set('followedByUserRequestError', '');
		case types.TOGGLE_FOLLOW_COMPANY_ERROR:
			return state.set('followedByUserRequested', false).set('followedByUserRequestError', value);
		case types.BLOCK_COMPANY_SUCCESS:
			return state.update('blockedByUser', function (f) {
				return !f;
			}).set('blockCompanyRequested', false);
		case types.BLOCK_COMPANY_REQUEST:
			return state.set('blockCompanyRequested', true).set('blockCompanyRequestError', '');
		case types.BLOCK_COMPANY_ERROR:
			return state.set('blockCompanyRequested', false).set('blockCompanyRequestError', value);
		default:
			return state;
	}
};

exports.initialCompanyProfileState = initialCompanyProfileState;
var _default = companyProfile;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(initialCompanyProfileState, 'initialCompanyProfileState', 'src/reducers/companyProfile.js');

	__REACT_HOT_LOADER__.register(companyProfile, 'companyProfile', 'src/reducers/companyProfile.js');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/reducers/companyProfile.js');
}();

;

/***/ }),

/***/ "5mwc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__recaptcha__ = __webpack_require__("ugB1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_async_script__ = __webpack_require__("pXJH");


var callbackName = "onloadcallback";
var globalName = "grecaptcha";

function getOptions() {
  return typeof window !== "undefined" && window.recaptchaOptions || {};
}

function getURL() {
  var dynamicOptions = getOptions();
  var hostname = dynamicOptions.useRecaptchaNet ? "recaptcha.net" : "www.google.com";
  return "https://" + hostname + "/recaptcha/api.js?onload=" + callbackName + "&render=explicit";
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_async_script__["a" /* default */])(getURL, {
  callbackName: callbackName,
  globalName: globalName
})(__WEBPACK_IMPORTED_MODULE_0__recaptcha__["a" /* default */]));

/***/ }),

/***/ "95fg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */
if (__webpack_require__.i({"NODE_ENV":"production"}).SPA_DEV) {
	module.exports = __webpack_require__("u7ui");
} else {
	module.exports = __webpack_require__("Geuy");
}
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}
}();

;

/***/ }),

/***/ "AA8j":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	fields: {
		paddingBottom: '20px'
	},

	actions: {
		display: 'flex',
		alignItems: 'center',
		paddingTop: '20px'
	}
};

/***/ }),

/***/ "CIye":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.initialState = undefined;

var _immutable = __webpack_require__("BYKG");

var _redux = __webpack_require__("2KeS");

var _actionTypes = __webpack_require__("ocry");

var types = _interopRequireWildcard(_actionTypes);

var _companyProfile = __webpack_require__("2ODj");

var _companyProfile2 = _interopRequireDefault(_companyProfile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var companyInfoReceived = function companyInfoReceived() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	var _ref = arguments[1];
	var type = _ref.type;

	switch (type) {
		case types.RECEIVE_COMPANY_INFO:
			return true;
		default:
			return state;
	}
};

var initialState = (0, _immutable.Map)({
	companyProfile: _companyProfile.initialCompanyProfileState,
	companyInfoReceived: companyInfoReceived
});

exports.initialState = initialState;

var _default = (0, _redux.combineReducers)({
	companyInfoReceived: companyInfoReceived,
	companyProfile: _companyProfile2.default
});

exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(companyInfoReceived, 'companyInfoReceived', 'src/reducers/index.js');

	__REACT_HOT_LOADER__.register(initialState, 'initialState', 'src/reducers/index.js');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/reducers/index.js');
}();

;

/***/ }),

/***/ "Geuy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _radium = __webpack_require__("Extj");

var _reactRedux = __webpack_require__("RH2O");

var _configureStore = __webpack_require__("eA2d");

var _configureStore2 = _interopRequireDefault(_configureStore);

var _WMCompanyPage = __webpack_require__("YksE");

var _WMCompanyPage2 = _interopRequireDefault(_WMCompanyPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var store = (0, _configureStore2.default)();

var WMCompanyPagesSPA = function WMCompanyPagesSPA(_ref) {
	var companyNumber = _ref.companyNumber,
	    csrf = _ref.csrf,
	    compact = _ref.compact,
	    isPublic = _ref.isPublic;

	return _react2.default.createElement(
		_radium.StyleRoot,
		null,
		_react2.default.createElement(
			_reactRedux.Provider,
			{ store: store },
			_react2.default.createElement(_WMCompanyPage2.default, {
				companyNumber: companyNumber,
				csrf: csrf,
				compact: compact,
				isPublic: isPublic
			})
		)
	);
};

var _default = WMCompanyPagesSPA;
exports.default = _default;


WMCompanyPagesSPA.propTypes = {
	companyNumber: _propTypes.PropTypes.string.isRequired,
	csrf: _propTypes.PropTypes.string.isRequired,
	compact: _propTypes.PropTypes.bool,
	isPublic: _propTypes.PropTypes.bool
};

WMCompanyPagesSPA.defaultProps = {
	isPublic: false
};
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(store, 'store', 'src/WMCompanyPagesSPA.build.js');

	__REACT_HOT_LOADER__.register(WMCompanyPagesSPA, 'WMCompanyPagesSPA', 'src/WMCompanyPagesSPA.build.js');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/WMCompanyPagesSPA.build.js');
}();

;

/***/ }),

/***/ "MTq+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _immutable = __webpack_require__("BYKG");

var CompanyOverview = new _immutable.Record({
	name: '',
	overview: '',
	website: '',
	avatar: '',
	location: new _immutable.Map({
		id: 0,
		name: '',
		number: '',
		addressLine1: '',
		addressLine2: '',
		city: '',
		state: '',
		zip: '',
		country: '',
		longitude: 0,
		latitude: 0,
		clientCompanyId: 0
	}),
	followedByUser: false,
	blockedByUser: false,
	blockCompanyRequested: false,
	blockCompanyRequestError: '',
	followedByUserRequested: false,
	followedByUserRequestError: '',
	yearFounded: 0,
	createdOn: '',
	workInviteSentToUserId: '',
	performWorkForClients: false,
	inVendorSearch: false,
	ratings: {},
	jobFunctions: new _immutable.List(),
	skills: new _immutable.List(),
	employees: 0,
	buyerScorecard: new _immutable.Map({
		paidWorkCount: 0,
		avgTimeToApproveWorkInDays: 0,
		avgTimeToPayWorkInDays: 0,
		satisfactionRate: 0
	}),
	talentPools: new _immutable.List()
});

var _default = CompanyOverview;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(CompanyOverview, 'CompanyOverview', 'src/reducers/records/CompanyOverview.js');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/reducers/records/CompanyOverview.js');
}();

;

/***/ }),

/***/ "QG8h":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _actions = __webpack_require__("nIup");

var actions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(_ref) {
	var companyInfoReceived = _ref.companyInfoReceived,
	    companyProfile = _ref.companyProfile;
	return {
		companyInfoReceived: companyInfoReceived,
		companyProfile: companyProfile
	};
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	var csrf = ownProps.csrf;

	return {
		fetchCompanyInfo: function fetchCompanyInfo(companyNumber, isPublic) {
			dispatch(actions.fetchCompanyInfo(companyNumber, isPublic, csrf));
		},
		toggleFollowCompany: function toggleFollowCompany(companyNumber, followedByUser) {
			dispatch(actions.toggleFollowCompany(companyNumber, csrf, followedByUser));
		}
	};
};
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'src/connect/index.js');

	__REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', 'src/connect/index.js');
}();

;

/***/ }),

/***/ "TtKq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () {
	function defineProperties(target, props) {
		for (var i = 0; i < props.length; i++) {
			var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		}
	}return function (Constructor, protoProps, staticProps) {
		if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	};
}();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ramda = __webpack_require__("tpu8");

var _WMRaisedButton = __webpack_require__("Sfwl");

var _WMRaisedButton2 = _interopRequireDefault(_WMRaisedButton);

var _styles = __webpack_require__("AA8j");

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) {
	return obj && obj.__esModule ? obj : { default: obj };
}

function _defineProperty(obj, key, value) {
	if (key in obj) {
		Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	} else {
		obj[key] = value;
	}return obj;
}

function _classCallCheck(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = {
	actions: _propTypes2.default.node,
	actionStyles: _propTypes2.default.object,
	fieldStyles: _propTypes2.default.object,
	children: _propTypes2.default.node.isRequired,
	disabled: _propTypes2.default.bool,
	onSubmit: _propTypes2.default.func.isRequired,
	submitText: _propTypes2.default.string
};

var WMValidatingForm = function (_Component) {
	_inherits(WMValidatingForm, _Component);

	function WMValidatingForm(props) {
		_classCallCheck(this, WMValidatingForm);

		var _this = _possibleConstructorReturn(this, (WMValidatingForm.__proto__ || Object.getPrototypeOf(WMValidatingForm)).call(this, props));

		_this.onValidate = function (_ref) {
			var name = _ref.name,
			    value = _ref.value,
			    isValid = _ref.isValid;

			_this.setState(_defineProperty({}, name, { value: value, isValid: isValid }));
		};

		_this.handleSubmit = function () {
			var form = (0, _ramda.map)(function (x) {
				return x.value;
			}, _this.state);

			_this.props.onSubmit(form);
		};

		_this.isFormValid = function () {
			return Object.keys(_this.state).every(function (field) {
				return _this.state[field].isValid;
			});
		};

		_this.state = {};
		return _this;
	}

	_createClass(WMValidatingForm, [{
		key: 'getChildContext',
		value: function getChildContext() {
			return {
				onValidate: this.onValidate
			};
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    actions = _props.actions,
			    actionStyles = _props.actionStyles,
			    fieldStyles = _props.fieldStyles,
			    children = _props.children,
			    _props$disabled = _props.disabled,
			    disabled = _props$disabled === undefined ? false : _props$disabled,
			    submitText = _props.submitText;

			return _react2.default.createElement('div', null, _react2.default.createElement('div', {
				'data-component-identifier': 'wm-validating-form__fields',
				style: Object.assign({}, _styles2.default.fields, fieldStyles)
			}, children), _react2.default.createElement('footer', {
				'data-component-identifier': 'wm-validating-form__actions',
				style: Object.assign({}, _styles2.default.actions, actionStyles)
			}, actions, _react2.default.createElement(_WMRaisedButton2.default, {
				'data-component-identifier': 'wm-validating-form__submit',
				primary: true,
				label: submitText || 'Submit',
				disabled: !this.isFormValid() || disabled,
				onClick: this.handleSubmit
			})));
		}
	}]);

	return WMValidatingForm;
}(_react.Component);

WMValidatingForm.childContextTypes = {
	onValidate: _propTypes2.default.func
};

exports.default = WMValidatingForm;

/***/ }),

/***/ "UUBb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _radium = __webpack_require__("Extj");

var _radium2 = _interopRequireDefault(_radium);

var _styles = __webpack_require__("n/VG");

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WMStatBlock = function WMStatBlock(_ref) {
	var title = _ref.title,
	    subtitle = _ref.subtitle,
	    titleStyle = _ref.titleStyle,
	    subtitleStyle = _ref.subtitleStyle;

	return _react2.default.createElement(
		'div',
		{
			style: _styles2.default.container,
			className: 'wm-stat__container'
		},
		_react2.default.createElement(
			'div',
			{
				style: [_styles2.default.subtitle, subtitleStyle],
				className: 'wm-stat__subtitle'
			},
			subtitle
		),
		_react2.default.createElement(
			'div',
			{
				style: [_styles2.default.title, titleStyle],
				className: 'wm-stat__title'
			},
			title
		)
	);
};

var _default = (0, _radium2.default)(WMStatBlock);

exports.default = _default;


WMStatBlock.propTypes = {
	title: _propTypes.PropTypes.string.isRequired,
	subtitle: _propTypes.PropTypes.string,
	titleStyle: _propTypes.PropTypes.object, // eslint-disable-line
	subtitleStyle: _propTypes.PropTypes.object // eslint-disable-line
};

WMStatBlock.defaultProps = {
	subtitle: ''
};
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(WMStatBlock, 'WMStatBlock', 'src/components/WMStat/index.js');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/WMStat/index.js');
}();

;

/***/ }),

/***/ "YksE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _reactRedux = __webpack_require__("RH2O");

var _radium = __webpack_require__("Extj");

var _radium2 = _interopRequireDefault(_radium);

var _WMCircularProgress = __webpack_require__("SuHq");

var _WMCircularProgress2 = _interopRequireDefault(_WMCircularProgress);

var _WMHeading = __webpack_require__("iXge");

var _WMHeading2 = _interopRequireDefault(_WMHeading);

var _WMMessageBanner = __webpack_require__("HQOJ");

var _WMMessageBanner2 = _interopRequireDefault(_WMMessageBanner);

var _connect = __webpack_require__("QG8h");

var _WMCompanyPageOverview = __webpack_require__("hCZN");

var _WMCompanyPageOverview2 = _interopRequireDefault(_WMCompanyPageOverview);

var _WMCompanyPageTalentPools = __webpack_require__("jtaW");

var _WMCompanyPageTalentPools2 = _interopRequireDefault(_WMCompanyPageTalentPools);

var _styles = __webpack_require__("1MJl");

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WMCompanyPage = function (_Component) {
	_inherits(WMCompanyPage, _Component);

	function WMCompanyPage() {
		_classCallCheck(this, WMCompanyPage);

		return _possibleConstructorReturn(this, (WMCompanyPage.__proto__ || Object.getPrototypeOf(WMCompanyPage)).apply(this, arguments));
	}

	_createClass(WMCompanyPage, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var _props = this.props,
			    companyNumber = _props.companyNumber,
			    fetchCompanyInfo = _props.fetchCompanyInfo,
			    csrf = _props.csrf,
			    isPublic = _props.isPublic;

			fetchCompanyInfo(companyNumber, isPublic, csrf);
		}
	}, {
		key: 'render',
		value: function render() {
			var _props2 = this.props,
			    companyInfoReceived = _props2.companyInfoReceived,
			    compact = _props2.compact,
			    companyNumber = _props2.companyNumber,
			    csrf = _props2.csrf,
			    isPublic = _props2.isPublic,
			    companyProfile = _props2.companyProfile;


			var blockProfileError = companyProfile.get('blockCompanyRequestError');
			return _react2.default.createElement(
				'div',
				{
					style: _styles2.default.body
				},
				companyInfoReceived ? _react2.default.createElement(
					'div',
					null,
					blockProfileError && _react2.default.createElement(
						_WMMessageBanner2.default,
						{
							status: 'error'
						},
						blockProfileError
					),
					_react2.default.createElement(_WMCompanyPageOverview2.default, {
						companyNumber: companyNumber,
						csrf: csrf,
						isPublic: isPublic
					}),
					!compact && _react2.default.createElement(_WMCompanyPageTalentPools2.default, null)
				) : _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_WMHeading2.default,
						{
							level: '1',
							style: _styles2.default.pageTitle(true)
						},
						'Loading Company Profile...'
					),
					_react2.default.createElement(_WMCircularProgress2.default, {
						mode: 'indeterminate',
						style: _styles2.default.loader
					})
				)
			);
		}
	}]);

	return WMCompanyPage;
}(_react.Component);

var _default = (0, _reactRedux.connect)(_connect.mapStateToProps, _connect.mapDispatchToProps)((0, _radium2.default)(WMCompanyPage));

exports.default = _default;


WMCompanyPage.propTypes = {
	companyNumber: _propTypes.PropTypes.string.isRequired,
	fetchCompanyInfo: _propTypes.PropTypes.func.isRequired,
	csrf: _propTypes.PropTypes.string.isRequired,
	companyInfoReceived: _propTypes.PropTypes.bool.isRequired,
	compact: _propTypes.PropTypes.bool,
	isPublic: _propTypes.PropTypes.bool,
	companyProfile: _propTypes.PropTypes.objectOf(_propTypes.PropTypes.any)
};

WMCompanyPage.defaultProps = {
	isPublic: false,
	compact: false,
	companyProfile: {}
};
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(WMCompanyPage, 'WMCompanyPage', 'src/components/WMCompanyPage/index.js');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/WMCompanyPage/index.js');
}();

;

/***/ }),

/***/ "eA2d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _redux = __webpack_require__("2KeS");

var _reduxThunk = __webpack_require__("bEzl");

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reduxLogger = __webpack_require__("oSVy");

var _immutable = __webpack_require__("BYKG");

var _reduxDevtoolsExtension = __webpack_require__("gFN5");

var _reducers = __webpack_require__("CIye");

var _reducers2 = _interopRequireDefault(_reducers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// set up logger
var stateTransformer = function stateTransformer(state) {
	// transform to JS for logging
	if (_immutable.Iterable.isIterable(state)) {
		return state.toJS();
	}
	return state;
};

var logger = (0, _reduxLogger.createLogger)({
	stateTransformer: stateTransformer
});

// set up middleware
var middlewares = [_reduxThunk2.default];
if (false) {
	middlewares.push(logger);
}
var composeEnhancers =  false ? _reduxDevtoolsExtension.composeWithDevTools : _redux.compose;
var configureStore = function configureStore() {
	var store = (0, _redux.createStore)(_reducers2.default, composeEnhancers(_redux.applyMiddleware.apply(undefined, middlewares)));

	if (false) {
		// enable webpack HMR for reducers
		module.hot.accept('../reducers', function () {
			var nextRootReducer = require('../reducers/'); // eslint-disable-line global-require
			store.replaceReducer(nextRootReducer);
		});
	}

	return store;
};

var _default = configureStore;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(stateTransformer, 'stateTransformer', 'src/configureStore/index.js');

	__REACT_HOT_LOADER__.register(logger, 'logger', 'src/configureStore/index.js');

	__REACT_HOT_LOADER__.register(middlewares, 'middlewares', 'src/configureStore/index.js');

	__REACT_HOT_LOADER__.register(composeEnhancers, 'composeEnhancers', 'src/configureStore/index.js');

	__REACT_HOT_LOADER__.register(configureStore, 'configureStore', 'src/configureStore/index.js');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/configureStore/index.js');
}();

;

/***/ }),

/***/ "gFN5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var compose = __webpack_require__("2KeS").compose;

exports.__esModule = true;
exports.composeWithDevTools =
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : function () {
        if (arguments.length === 0) return undefined;
        if (typeof arguments[0] === 'object') return compose;
        return compose.apply(null, arguments);
      };

exports.devToolsEnhancer =
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__
    ? window.__REDUX_DEVTOOLS_EXTENSION__
    : function () {
        return function (noop) {
          return noop;
        };
      };


/***/ }),

/***/ "hCZN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactRedux = __webpack_require__("RH2O");

var _template = __webpack_require__("yGNV");

var _template2 = _interopRequireDefault(_template);

var _actions = __webpack_require__("nIup");

var actions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(_ref) {
	var companyProfile = _ref.companyProfile;
	return {
		name: companyProfile.name,
		website: companyProfile.website,
		location: companyProfile.location,
		avatar: companyProfile.avatar,
		yearFounded: companyProfile.yearFounded,
		createdOn: companyProfile.createdOn,
		employees: companyProfile.employees,
		overview: companyProfile.overview,
		followedByUser: companyProfile.followedByUser,
		followedByUserRequested: companyProfile.followedByUserRequested,
		followedByUserRequestError: companyProfile.followedByUserRequestError,
		blockedByUser: companyProfile.blockedByUser,
		blockCompanyRequested: companyProfile.blockCompanyRequested,
		blockCompanyRequestError: companyProfile.blockCompanyRequestError
	};
};

var mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
	var followedByUser = stateProps.followedByUser;
	var dispatch = dispatchProps.dispatch;
	var csrf = ownProps.csrf,
	    companyNumber = ownProps.companyNumber;


	return _extends({}, stateProps, ownProps, {
		toggleFollowCompany: function toggleFollowCompany() {
			return dispatch(actions.toggleFollowCompany(companyNumber, csrf, followedByUser));
		},
		blockFunc: function blockFunc() {
			return dispatch(actions.blockCompany(companyNumber, csrf));
		}
	});
};

var _default = (0, _reactRedux.connect)(mapStateToProps, null, mergeProps)(_template2.default);

exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'src/components/WMCompanyPageOverview/index.js');

	__REACT_HOT_LOADER__.register(mergeProps, 'mergeProps', 'src/components/WMCompanyPageOverview/index.js');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/WMCompanyPageOverview/index.js');
}();

;

/***/ }),

/***/ "ifzK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _immutable = __webpack_require__("BYKG");

var _WMPaper = __webpack_require__("lJ/E");

var _WMPaper2 = _interopRequireDefault(_WMPaper);

var _WMHeading = __webpack_require__("iXge");

var _WMHeading2 = _interopRequireDefault(_WMHeading);

var _WMTable = __webpack_require__("jqbJ");

var _WMTable2 = _interopRequireDefault(_WMTable);

var _WMTableBody = __webpack_require__("ljjz");

var _WMTableBody2 = _interopRequireDefault(_WMTableBody);

var _WMTableRow = __webpack_require__("HrTT");

var _WMTableRow2 = _interopRequireDefault(_WMTableRow);

var _WMTableCell = __webpack_require__("jLbG");

var _WMTableCell2 = _interopRequireDefault(_WMTableCell);

var _WMTableHeader = __webpack_require__("ZbWw");

var _WMTableHeader2 = _interopRequireDefault(_WMTableHeader);

var _WMTableHeaderCell = __webpack_require__("/2rN");

var _WMTableHeaderCell2 = _interopRequireDefault(_WMTableHeaderCell);

var _WMRaisedButton = __webpack_require__("Sfwl");

var _WMRaisedButton2 = _interopRequireDefault(_WMRaisedButton);

var _WMStat = __webpack_require__("UUBb");

var _WMStat2 = _interopRequireDefault(_WMStat);

var _styles = __webpack_require__("0Ajs");

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getComponentIdentifier = function getComponentIdentifier(id) {
	return 'wm-company-page__talent-pools__' + id;
};
var truncatePoolDescription = function truncatePoolDescription(rawDescription) {
	return rawDescription.slice(0, 200) + '...';
};

var WMCompanyPagesTalentPools = function WMCompanyPagesTalentPools(_ref) {
	var talentPools = _ref.talentPools,
	    name = _ref.name,
	    satisfactionRate = _ref.satisfactionRate,
	    avgTimeToPayWorkInDays = _ref.avgTimeToPayWorkInDays,
	    avgTimeToApproveWorkInDays = _ref.avgTimeToApproveWorkInDays;

	var paymentTimelinessLabel = void 0;
	if (avgTimeToPayWorkInDays < 0) {
		paymentTimelinessLabel = 'Early';
	} else if (avgTimeToPayWorkInDays >= 0 && avgTimeToPayWorkInDays < 1) {
		paymentTimelinessLabel = 'On Time';
	} else {
		paymentTimelinessLabel = 'Late';
	}
	var tableBody = talentPools.map(function (pool) {
		return _react2.default.createElement(
			_WMTableRow2.default,
			{
				key: pool.get('id')
			},
			_react2.default.createElement(
				_WMTableCell2.default,
				{
					style: _styles2.default.poolName
				},
				pool.get('name')
			),
			_react2.default.createElement(
				_WMTableCell2.default,
				{
					style: _styles2.default.tableBodyText
				},
				pool.get('description').length > 200 ? truncatePoolDescription(pool.get('description')) : pool.get('description')
			),
			_react2.default.createElement(
				_WMTableCell2.default,
				{
					style: _styles2.default.tableBodyText
				},
				pool.get('requirementsMet') + ' of ' + pool.get('requirements')
			),
			_react2.default.createElement(
				_WMTableCell2.default,
				null,
				_react2.default.createElement(_WMRaisedButton2.default, {
					label: 'JOIN',
					href: '/groups/' + pool.get('id'),
					secondary: true
				})
			)
		);
	});
	return _react2.default.createElement(
		_WMPaper2.default,
		{
			rounded: false,
			style: _styles2.default.container,
			zDepth: 2
		},
		_react2.default.createElement(
			'div',
			{
				style: _styles2.default.inner
			},
			_react2.default.createElement(
				_WMHeading2.default,
				{
					level: '3',
					style: _styles2.default.header
				},
				'Work for ' + name
			),
			_react2.default.createElement(
				'div',
				{
					style: _styles2.default.statsContainer,
					'data-attr-id': 'wm-company-page__stats-container'
				},
				_react2.default.createElement(_WMStat2.default, {
					title: satisfactionRate + '%',
					subtitle: 'Satisfaction'
				}),
				_react2.default.createElement(_WMStat2.default, {
					title: paymentTimelinessLabel,
					subtitle: 'Payment Timeliness'
				}),
				_react2.default.createElement(_WMStat2.default, {
					title: avgTimeToApproveWorkInDays + ' days',
					subtitle: 'Approval Time'
				})
			)
		),
		talentPools.size > 0 && _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement(
				_WMHeading2.default,
				{
					style: _styles2.default.inner,
					level: '4'
				},
				'Join our Labor Clouds to be notified when new work becomes available.'
			),
			_react2.default.createElement(
				_WMTable2.default,
				{
					hideDisabledCheckboxes: true,
					striped: true
				},
				_react2.default.createElement(
					_WMTableHeader2.default,
					null,
					_react2.default.createElement(
						_WMTableHeaderCell2.default,
						{
							'data-attr-id': getComponentIdentifier('name-header-cell')
						},
						'Labor Cloud'
					),
					_react2.default.createElement(
						_WMTableHeaderCell2.default,
						{
							'data-attr-id': getComponentIdentifier('description-header-cell')
						},
						'Description'
					),
					_react2.default.createElement(
						_WMTableHeaderCell2.default,
						{
							'data-attr-id': getComponentIdentifier('requirements-header-cell')
						},
						'Requirements You Meet'
					),
					_react2.default.createElement(
						_WMTableHeaderCell2.default,
						{
							'data-attr-id': getComponentIdentifier('apply-header-cell')
						},
						''
					)
				),
				_react2.default.createElement(
					_WMTableBody2.default,
					null,
					tableBody.toJS()
				)
			)
		)
	);
};

var _default = WMCompanyPagesTalentPools;
exports.default = _default;


WMCompanyPagesTalentPools.propTypes = {
	name: _propTypes.PropTypes.string.isRequired,
	talentPools: _propTypes.PropTypes.instanceOf(_immutable.List),
	satisfactionRate: _propTypes.PropTypes.number.isRequired,
	avgTimeToPayWorkInDays: _propTypes.PropTypes.number.isRequired,
	avgTimeToApproveWorkInDays: _propTypes.PropTypes.number.isRequired
};

WMCompanyPagesTalentPools.defaultProps = {
	talentPools: []
};
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(getComponentIdentifier, 'getComponentIdentifier', 'src/components/WMCompanyPageTalentPools/template.js');

	__REACT_HOT_LOADER__.register(truncatePoolDescription, 'truncatePoolDescription', 'src/components/WMCompanyPageTalentPools/template.js');

	__REACT_HOT_LOADER__.register(WMCompanyPagesTalentPools, 'WMCompanyPagesTalentPools', 'src/components/WMCompanyPageTalentPools/template.js');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/WMCompanyPageTalentPools/template.js');
}();

;

/***/ }),

/***/ "jtaW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _reactRedux = __webpack_require__("RH2O");

var _template = __webpack_require__("ifzK");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(_ref) {
	var companyProfile = _ref.companyProfile;
	return {
		name: companyProfile.name,
		talentPools: companyProfile.talentPools,
		satisfactionRate: companyProfile.buyerScorecard.get('satisfactionRate'),
		avgTimeToPayWorkInDays: companyProfile.buyerScorecard.get('avgTimeToPayWorkInDays'),
		avgTimeToApproveWorkInDays: companyProfile.buyerScorecard.get('avgTimeToApproveWorkInDays')
	};
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(_template2.default);

exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'src/components/WMCompanyPageTalentPools/index.js');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/WMCompanyPageTalentPools/index.js');
}();

;

/***/ }),

/***/ "kSyU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _styles = __webpack_require__("7GIY");

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var baseColors = _styles2.default.colors.baseColors;
var _default = {
	colors: baseColors
};
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(baseColors, 'baseColors', 'src/common/styles.js');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/common/styles.js');
}();

;

/***/ }),

/***/ "n/VG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _styles = __webpack_require__("kSyU");

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var colors = _styles2.default.colors;
var _default = {
	container: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-around',
		alignItems: 'center',
		background: colors.offWhite,
		width: '32%',
		height: '6.2em',
		padding: '0.5em 0',
		boxSizing: 'border-box'
	},
	title: {
		fontSize: '2.14em',
		color: colors.green,
		fontWeight: '300'
	}
};
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(colors, 'colors', 'src/components/WMStat/styles/index.js');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/WMStat/styles/index.js');
}();

;

/***/ }),

/***/ "nIup":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.blockCompany = exports.toggleFollowCompany = exports.receiveCompanyInfo = exports.fetchCompanyInfo = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _isomorphicFetch = __webpack_require__("j9g7");

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _actionTypes = __webpack_require__("ocry");

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var BASE_URL = '';
if (__webpack_require__.i({"NODE_ENV":"production"}).SPA_DEV) {
	BASE_URL = 'http://localhost:9001';
}

var makeActionCreator = function makeActionCreator(type) {
	for (var _len = arguments.length, argNames = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		argNames[_key - 1] = arguments[_key];
	}

	return function () {
		for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
			args[_key2] = arguments[_key2];
		}

		var action = { type: type };

		argNames.forEach(function (arg, index) {
			action[argNames[index]] = args[index];
		});

		return action;
	};
};

var receiveCompanyInfo = makeActionCreator(types.RECEIVE_COMPANY_INFO, 'value');

var fetchCompanyInfo = function fetchCompanyInfo(companyNumber, isPublic, csrf) {
	var baseUrl = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : BASE_URL;
	return function (dispatch) {
		dispatch({
			type: types.COMPANY_INFO_REQUEST
		});
		return (0, _isomorphicFetch2.default)(baseUrl + '/employer/v2/settings/profile/' + (isPublic ? 'public/' : '') + companyNumber, {
			credentials: 'same-origin',
			method: 'get',
			headers: new Headers({
				'Content-Type': 'application/json',
				'X-CSRF-Token': csrf
			})
		}).then(function (res) {
			if (!res.ok) {
				// request error, dispatch error message
				return res.json().then(function () {
					// TODO[tim-mc] figure out if there's any custom error message relayed here
					// if not, forget trying to parse the json
					dispatch({
						type: types.COMPANY_INFO_REQUEST_ERROR
					});
				});
			}
			return res.json().then(function (response) {
				// request successful, dispatch response
				var results = response.results;

				dispatch({
					type: types.RECEIVE_COMPANY_INFO,
					value: results[0]
				});
			});
		});
	};
};

var toggleFollowCompany = function toggleFollowCompany(companyNumber, csrf, followedByUser) {
	var baseUrl = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : BASE_URL;
	return function () {
		var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
			var success;
			return regeneratorRuntime.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							dispatch({
								type: types.TOGGLE_FOLLOW_COMPANY_REQUEST
							});
							_context.prev = 1;
							_context.next = 4;
							return (0, _isomorphicFetch2.default)(baseUrl + '/employer/v2/settings/profile/' + companyNumber + '/follower', {
								credentials: 'same-origin',
								method: followedByUser ? 'DELETE' : 'POST',
								headers: new Headers({
									'Content-Type': 'application/json',
									'X-CSRF-Token': csrf
								})
							}).then(function (res) {
								return res.ok;
							});

						case 4:
							success = _context.sent;

							if (success) {
								dispatch({
									type: types.TOGGLE_FOLLOW_COMPANY
								});
							}
							_context.next = 11;
							break;

						case 8:
							_context.prev = 8;
							_context.t0 = _context['catch'](1);

							dispatch({
								type: types.TOGGLE_FOLLOW_COMPANY_ERROR,
								value: _context.t0
							});

						case 11:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, undefined, [[1, 8]]);
		}));

		return function (_x3) {
			return _ref.apply(this, arguments);
		};
	}();
};

var blockCompany = function blockCompany(companyNumber, csrf) {
	var baseUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : BASE_URL;
	return function () {
		var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
			return regeneratorRuntime.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							dispatch({
								type: types.BLOCK_COMPANY_REQUEST
							});
							_context2.next = 3;
							return (0, _isomorphicFetch2.default)(baseUrl + '/user/block_company/' + companyNumber, {
								credentials: 'same-origin',
								method: 'POST',
								headers: new Headers({
									'Content-Type': 'application/json',
									'X-CSRF-Token': csrf
								})
							}).then(function (res) {
								if (!((typeof res === 'undefined' ? 'undefined' : _typeof(res)) === 'object' && res.ok)) {
									dispatch({ type: types.BLOCK_COMPANY_ERROR });
									throw new Error('Block company failed');
								}
								return res.json();
							}).then(function (response) {
								var successful = response.successful;

								if (!successful) {
									var errMsg = response.messages[0];
									dispatch({ type: types.BLOCK_COMPANY_ERROR, value: errMsg });
									throw new Error('Block company failed');
								}
								dispatch({ type: types.BLOCK_COMPANY_SUCCESS });
							});

						case 3:
						case 'end':
							return _context2.stop();
					}
				}
			}, _callee2, undefined);
		}));

		return function (_x5) {
			return _ref2.apply(this, arguments);
		};
	}();
};

exports.fetchCompanyInfo = fetchCompanyInfo;
exports.receiveCompanyInfo = receiveCompanyInfo;
exports.toggleFollowCompany = toggleFollowCompany;
exports.blockCompany = blockCompany;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(BASE_URL, 'BASE_URL', 'src/actions/index.js');

	__REACT_HOT_LOADER__.register(makeActionCreator, 'makeActionCreator', 'src/actions/index.js');

	__REACT_HOT_LOADER__.register(receiveCompanyInfo, 'receiveCompanyInfo', 'src/actions/index.js');

	__REACT_HOT_LOADER__.register(fetchCompanyInfo, 'fetchCompanyInfo', 'src/actions/index.js');

	__REACT_HOT_LOADER__.register(toggleFollowCompany, 'toggleFollowCompany', 'src/actions/index.js');

	__REACT_HOT_LOADER__.register(blockCompany, 'blockCompany', 'src/actions/index.js');
}();

;

/***/ }),

/***/ "nT0y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__recaptcha_wrapper__ = __webpack_require__("5mwc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__recaptcha__ = __webpack_require__("ugB1");
/* unused harmony reexport ReCAPTCHA */


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__recaptcha_wrapper__["a" /* default */]);


/***/ }),

/***/ "nsQX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _styles = __webpack_require__("kSyU");

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var colors = _styles2.default.colors;

var columnStyle = {
	display: 'flex',
	flexFlow: 'column nowrap',
	margin: '0 0 2em'
};
var columnLeftStyle = _extends({}, columnStyle, {
	width: '33%',
	minWidth: '200px',
	margin: '1em 1em 0 0'
});
var columnRightStyle = _extends({}, columnStyle, {
	width: '56%',
	minWidth: '200px'
});
var columnFullStyle = _extends({}, columnStyle, {
	width: '89%',
	justifyContent: 'space-around'
});

var _default = {
	container: {
		width: '100%',
		padding: '2em 1.86em',
		minHeight: '14.43em',
		margin: '0 0 2em'
	},
	columns: {
		display: 'flex',
		flexFlow: 'row wrap',
		alignItems: 'flex-start',
		justifyContent: 'space-around'
	},
	getColumnStyle: function getColumnStyle() {
		var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'right';

		if (direction === 'left') {
			return columnLeftStyle;
		} else if (direction === 'none') {
			return columnFullStyle;
		}
		return columnRightStyle;
	},
	overviewItem: {
		display: 'flex',
		flexFlow: 'row nowrap',
		justifyContent: 'flex-start',
		padding: '0.5em 0'
	},
	overviewItemIcon: {
		fontSize: '2.2em'
	},
	overviewItemLabel: {
		color: colors.grey,
		margin: '0 0 0 0.86em',
		fontSize: '1em'
	},
	overviewText: {
		fontSize: '1em'
	},
	avatar: {
		maxWidth: '100%',
		maxHeight: '6.5em'
	},
	followButton: {
		width: '160px',
		borderRadius: '2px',
		backgroundColor: '#53b3f3',
		boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.24), 0 0 2px 0 rgba(0, 0, 0, 0.12)'
	},
	followButtonLabel: {
		fontSize: '14px',
		color: '#ffffff'
	},
	blockButton: {
		width: '160px',
		borderRadius: '2px',
		backgroundColor: '#53b3f3',
		boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.24), 0 0 2px 0 rgba(0, 0, 0, 0.12)',
		marginLeft: '1em',
		whiteSpace: 'noWrap'
	},
	blockButtonLabel: {
		fontFamily: 'OpenSans',
		fontSize: '14px',
		color: '#ffffff'
	},
	actionContainer: {
		float: 'right'
	},
	followButtonColors: {
		follow: '#53b3f3',
		following: '#5bc75d'
	}
};
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(colors, 'colors', 'src/components/WMCompanyPageOverview/styles/index.js');

	__REACT_HOT_LOADER__.register(columnStyle, 'columnStyle', 'src/components/WMCompanyPageOverview/styles/index.js');

	__REACT_HOT_LOADER__.register(columnLeftStyle, 'columnLeftStyle', 'src/components/WMCompanyPageOverview/styles/index.js');

	__REACT_HOT_LOADER__.register(columnRightStyle, 'columnRightStyle', 'src/components/WMCompanyPageOverview/styles/index.js');

	__REACT_HOT_LOADER__.register(columnFullStyle, 'columnFullStyle', 'src/components/WMCompanyPageOverview/styles/index.js');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/WMCompanyPageOverview/styles/index.js');
}();

;

/***/ }),

/***/ "ocry":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var RECEIVE_COMPANY_INFO = exports.RECEIVE_COMPANY_INFO = 'RECEIVE_COMPANY_INFO';
var FETCH_COMPANY_INFO = exports.FETCH_COMPANY_INFO = 'FETCH_COMPANY_INFO';
var COMPANY_INFO_REQUEST = exports.COMPANY_INFO_REQUEST = 'COMPANY_INFO_REQUEST';
var COMPANY_INFO_REQUEST_ERROR = exports.COMPANY_INFO_REQUEST_ERROR = 'COMPANY_INFO_REQUEST_ERROR';
var TOGGLE_FOLLOW_COMPANY_REQUEST = exports.TOGGLE_FOLLOW_COMPANY_REQUEST = 'TOGGLE_FOLLOW_COMPANY_REQUEST';
var TOGGLE_FOLLOW_COMPANY_ERROR = exports.TOGGLE_FOLLOW_COMPANY_ERROR = 'TOGGLE_FOLLOW_COMPANY_ERROR';
var TOGGLE_FOLLOW_COMPANY = exports.TOGGLE_FOLLOW_COMPANY = 'TOGGLE_FOLLOW_COMPANY';
var BLOCK_COMPANY_REQUEST = exports.BLOCK_COMPANY_REQUEST = 'BLOCK_COMPANY_REQUEST';
var BLOCK_COMPANY_SUCCESS = exports.BLOCK_COMPANY_SUCCESS = 'BLOCK_COMPANY_SUCCESSS';
var BLOCK_COMPANY_ERROR = exports.BLOCK_COMPANY_ERROR = 'BLOCK_COMPANY_ERROR';
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(RECEIVE_COMPANY_INFO, 'RECEIVE_COMPANY_INFO', 'src/constants/actionTypes.js');

  __REACT_HOT_LOADER__.register(FETCH_COMPANY_INFO, 'FETCH_COMPANY_INFO', 'src/constants/actionTypes.js');

  __REACT_HOT_LOADER__.register(COMPANY_INFO_REQUEST, 'COMPANY_INFO_REQUEST', 'src/constants/actionTypes.js');

  __REACT_HOT_LOADER__.register(COMPANY_INFO_REQUEST_ERROR, 'COMPANY_INFO_REQUEST_ERROR', 'src/constants/actionTypes.js');

  __REACT_HOT_LOADER__.register(TOGGLE_FOLLOW_COMPANY_REQUEST, 'TOGGLE_FOLLOW_COMPANY_REQUEST', 'src/constants/actionTypes.js');

  __REACT_HOT_LOADER__.register(TOGGLE_FOLLOW_COMPANY_ERROR, 'TOGGLE_FOLLOW_COMPANY_ERROR', 'src/constants/actionTypes.js');

  __REACT_HOT_LOADER__.register(TOGGLE_FOLLOW_COMPANY, 'TOGGLE_FOLLOW_COMPANY', 'src/constants/actionTypes.js');

  __REACT_HOT_LOADER__.register(BLOCK_COMPANY_REQUEST, 'BLOCK_COMPANY_REQUEST', 'src/constants/actionTypes.js');

  __REACT_HOT_LOADER__.register(BLOCK_COMPANY_SUCCESS, 'BLOCK_COMPANY_SUCCESS', 'src/constants/actionTypes.js');

  __REACT_HOT_LOADER__.register(BLOCK_COMPANY_ERROR, 'BLOCK_COMPANY_ERROR', 'src/constants/actionTypes.js');
}();

;

/***/ }),

/***/ "pXJH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__("wfLM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony export (immutable) */ __webpack_exports__["a"] = makeAsyncScript;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];
  }return target;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);subClass.prototype.constructor = subClass;subClass.__proto__ = superClass;
}




var SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function

var idCount = 0;
function makeAsyncScript(getScriptURL, options) {
  options = options || {};
  return function wrapWithAsyncScript(WrappedComponent) {
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";

    var AsyncScriptLoader =
    /*#__PURE__*/
    function (_Component) {
      _inheritsLoose(AsyncScriptLoader, _Component);

      function AsyncScriptLoader(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.state = {};
        _this.__scriptURL = "";
        return _this;
      }

      var _proto = AsyncScriptLoader.prototype;

      _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
        if (!this.__scriptLoaderID) {
          this.__scriptLoaderID = "async-script-loader-" + idCount++;
        }

        return this.__scriptLoaderID;
      };

      _proto.setupScriptURL = function setupScriptURL() {
        this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
        return this.__scriptURL;
      };

      _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
        var _this2 = this;

        // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
        this.setState(state, function () {
          return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
        });
      };

      _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
        var mapEntry = SCRIPT_MAP[this.__scriptURL];

        if (!mapEntry || !mapEntry.loaded) {
          throw new Error("Script is not loaded.");
        }

        for (var obsKey in mapEntry.observers) {
          mapEntry.observers[obsKey](mapEntry);
        }

        delete window[options.callbackName];
      };

      _proto.componentDidMount = function componentDidMount() {
        var _this3 = this;

        var scriptURL = this.setupScriptURL();
        var key = this.asyncScriptLoaderGetScriptLoaderID();
        var _options = options,
            globalName = _options.globalName,
            callbackName = _options.callbackName,
            scriptId = _options.scriptId; // check if global object already attached to window

        if (globalName && typeof window[globalName] !== "undefined") {
          SCRIPT_MAP[scriptURL] = {
            loaded: true,
            observers: {}
          };
        } // check if script loading already


        if (SCRIPT_MAP[scriptURL]) {
          var entry = SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"

          if (entry && (entry.loaded || entry.errored)) {
            this.asyncScriptLoaderHandleLoad(entry);
            return;
          } // if still loading then callback to observer queue


          entry.observers[key] = function (entry) {
            return _this3.asyncScriptLoaderHandleLoad(entry);
          };

          return;
        }
        /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */

        var observers = {};

        observers[key] = function (entry) {
          return _this3.asyncScriptLoaderHandleLoad(entry);
        };

        SCRIPT_MAP[scriptURL] = {
          loaded: false,
          observers: observers
        };
        var script = document.createElement("script");
        script.src = scriptURL;
        script.async = true;

        for (var attribute in options.attributes) {
          script.setAttribute(attribute, options.attributes[attribute]);
        }

        if (scriptId) {
          script.id = scriptId;
        }

        var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
          if (SCRIPT_MAP[scriptURL]) {
            var mapEntry = SCRIPT_MAP[scriptURL];
            var observersMap = mapEntry.observers;

            for (var obsKey in observersMap) {
              if (func(observersMap[obsKey])) {
                delete observersMap[obsKey];
              }
            }
          }
        };

        if (callbackName && typeof window !== "undefined") {
          window[callbackName] = function () {
            return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
          };
        }

        script.onload = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.loaded = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              if (callbackName) {
                return false;
              }

              observer(mapEntry);
              return true;
            });
          }
        };

        script.onerror = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.errored = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              observer(mapEntry);
              return true;
            });
          }
        };

        document.body.appendChild(script);
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        // Remove tag script
        var scriptURL = this.__scriptURL;

        if (options.removeOnUnmount === true) {
          var allScripts = document.getElementsByTagName("script");

          for (var i = 0; i < allScripts.length; i += 1) {
            if (allScripts[i].src.indexOf(scriptURL) > -1) {
              if (allScripts[i].parentNode) {
                allScripts[i].parentNode.removeChild(allScripts[i]);
              }
            }
          }
        } // Clean the observer entry


        var mapEntry = SCRIPT_MAP[scriptURL];

        if (mapEntry) {
          delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];

          if (options.removeOnUnmount === true) {
            delete SCRIPT_MAP[scriptURL];
          }
        }
      };

      _proto.render = function render() {
        var globalName = options.globalName; // remove asyncScriptOnLoad from childProps

        var _this$props = this.props,
            asyncScriptOnLoad = _this$props.asyncScriptOnLoad,
            forwardedRef = _this$props.forwardedRef,
            childProps = _objectWithoutPropertiesLoose(_this$props, ["asyncScriptOnLoad", "forwardedRef"]); // eslint-disable-line no-unused-vars


        if (globalName && typeof window !== "undefined") {
          childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
        }

        childProps.ref = forwardedRef;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(WrappedComponent, childProps);
      };

      return AsyncScriptLoader;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]); // Note the second param "ref" provided by React.forwardRef.
    // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
    // And it can then be attached to the Component.


    var ForwardedComponent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"])(function (props, ref) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(AsyncScriptLoader, _extends({}, props, {
        forwardedRef: ref
      }));
    });
    ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
    ForwardedComponent.propTypes = {
      asyncScriptOnLoad: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
    };
    return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(ForwardedComponent, WrappedComponent);
  };
}

/***/ }),

/***/ "u7ui":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _radium = __webpack_require__("Extj");

var _reactRedux = __webpack_require__("RH2O");

var _WMCompanyPage = __webpack_require__("YksE");

var _WMCompanyPage2 = _interopRequireDefault(_WMCompanyPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WMCompanyPagesSPA = function WMCompanyPagesSPA(_ref) {
	var companyNumber = _ref.companyNumber,
	    csrf = _ref.csrf,
	    compact = _ref.compact,
	    isPublic = _ref.isPublic,
	    store = _ref.store;

	return _react2.default.createElement(
		_radium.StyleRoot,
		null,
		_react2.default.createElement(
			_reactRedux.Provider,
			{ store: store },
			_react2.default.createElement(_WMCompanyPage2.default, {
				companyNumber: companyNumber,
				csrf: csrf,
				compact: compact,
				isPublic: isPublic
			})
		)
	);
};

var _default = WMCompanyPagesSPA;
exports.default = _default;


WMCompanyPagesSPA.propTypes = {
	companyNumber: _propTypes.PropTypes.string.isRequired,
	csrf: _propTypes.PropTypes.string.isRequired,
	compact: _propTypes.PropTypes.bool,
	isPublic: _propTypes.PropTypes.bool,
	store: _propTypes.PropTypes.object.isRequired // eslint-disable-line
};

WMCompanyPagesSPA.defaultProps = {
	isPublic: false,
	compact: false
};
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(WMCompanyPagesSPA, 'WMCompanyPagesSPA', 'src/WMCompanyPagesSPA.dev.js');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/WMCompanyPagesSPA.dev.js');
}();

;

/***/ }),

/***/ "ugB1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReCAPTCHA; });
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];
  }return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);subClass.prototype.constructor = subClass;subClass.__proto__ = superClass;
}




var ReCAPTCHA =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReCAPTCHA, _React$Component);

  function ReCAPTCHA() {
    var _this;

    _this = _React$Component.call(this) || this;
    _this.handleExpired = _this.handleExpired.bind(_assertThisInitialized(_this));
    _this.handleErrored = _this.handleErrored.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = ReCAPTCHA.prototype;

  _proto.getValue = function getValue() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this.props.grecaptcha.getResponse(this._widgetId);
    }

    return null;
  };

  _proto.getWidgetId = function getWidgetId() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this._widgetId;
    }

    return null;
  };

  _proto.execute = function execute() {
    var grecaptcha = this.props.grecaptcha;

    if (grecaptcha && this._widgetId !== undefined) {
      return grecaptcha.execute(this._widgetId);
    } else {
      this._executeRequested = true;
    }
  };

  _proto.executeAsync = function executeAsync() {
    var _this2 = this;

    return new Promise(function (resolve, reject) {
      _this2.executionResolve = resolve;
      _this2.executionReject = reject;

      _this2.execute();
    });
  };

  _proto.reset = function reset() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      this.props.grecaptcha.reset(this._widgetId);
    }
  };

  _proto.handleExpired = function handleExpired() {
    if (this.props.onExpired) {
      this.props.onExpired();
    } else {
      this.handleChange(null);
    }
  };

  _proto.handleErrored = function handleErrored() {
    if (this.props.onErrored) {
      this.props.onErrored();
    }

    if (this.executionReject) {
      this.executionReject();
      delete this.executionResolve;
      delete this.executionReject;
    }
  };

  _proto.handleChange = function handleChange(token) {
    if (this.props.onChange) {
      this.props.onChange(token);
    }

    if (this.executionResolve) {
      this.executionResolve(token);
      delete this.executionReject;
      delete this.executionResolve;
    }
  };

  _proto.explicitRender = function explicitRender() {
    if (this.props.grecaptcha && this.props.grecaptcha.render && this._widgetId === undefined) {
      var wrapper = document.createElement("div");
      this._widgetId = this.props.grecaptcha.render(wrapper, {
        sitekey: this.props.sitekey,
        callback: this.handleChange,
        theme: this.props.theme,
        type: this.props.type,
        tabindex: this.props.tabindex,
        "expired-callback": this.handleExpired,
        "error-callback": this.handleErrored,
        size: this.props.size,
        stoken: this.props.stoken,
        hl: this.props.hl,
        badge: this.props.badge
      });
      this.captcha.appendChild(wrapper);
    }

    if (this._executeRequested && this.props.grecaptcha && this._widgetId !== undefined) {
      this._executeRequested = false;
      this.execute();
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    this.explicitRender();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.explicitRender();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this._widgetId !== undefined) {
      this.delayOfCaptchaIframeRemoving();
      this.reset();
    }
  };

  _proto.delayOfCaptchaIframeRemoving = function delayOfCaptchaIframeRemoving() {
    var temporaryNode = document.createElement("div");
    document.body.appendChild(temporaryNode);
    temporaryNode.style.display = "none"; // move of the recaptcha to a temporary node

    while (this.captcha.firstChild) {
      temporaryNode.appendChild(this.captcha.firstChild);
    } // delete the temporary node after reset will be done


    setTimeout(function () {
      document.body.removeChild(temporaryNode);
    }, 5000);
  };

  _proto.handleRecaptchaRef = function handleRecaptchaRef(elem) {
    this.captcha = elem;
  };

  _proto.render = function render() {
    // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.

    /* eslint-disable no-unused-vars */
    var _this$props = this.props,
        sitekey = _this$props.sitekey,
        onChange = _this$props.onChange,
        theme = _this$props.theme,
        type = _this$props.type,
        tabindex = _this$props.tabindex,
        onExpired = _this$props.onExpired,
        onErrored = _this$props.onErrored,
        size = _this$props.size,
        stoken = _this$props.stoken,
        grecaptcha = _this$props.grecaptcha,
        badge = _this$props.badge,
        hl = _this$props.hl,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "onErrored", "size", "stoken", "grecaptcha", "badge", "hl"]);
    /* eslint-enable no-unused-vars */

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({}, childProps, {
      ref: this.handleRecaptchaRef
    }));
  };

  return ReCAPTCHA;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);


ReCAPTCHA.displayName = "ReCAPTCHA";
ReCAPTCHA.propTypes = {
  sitekey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  grecaptcha: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["dark", "light"]),
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["image", "audio"]),
  tabindex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onExpired: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onErrored: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["compact", "normal", "invisible"]),
  stoken: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  hl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  badge: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["bottomright", "bottomleft", "inline"])
};
ReCAPTCHA.defaultProps = {
  onChange: function onChange() {},
  theme: "light",
  type: "image",
  tabindex: 0,
  size: "normal",
  badge: "bottomright"
};

/***/ }),

/***/ "yGNV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _WMPaper = __webpack_require__("lJ/E");

var _WMPaper2 = _interopRequireDefault(_WMPaper);

var _WMHeading = __webpack_require__("iXge");

var _WMHeading2 = _interopRequireDefault(_WMHeading);

var _WMText = __webpack_require__("RjQT");

var _WMText2 = _interopRequireDefault(_WMText);

var _WMFontIcon = __webpack_require__("yWpH");

var _WMFontIcon2 = _interopRequireDefault(_WMFontIcon);

var _WMRaisedButton = __webpack_require__("Sfwl");

var _WMRaisedButton2 = _interopRequireDefault(_WMRaisedButton);

var _styles = __webpack_require__("7GIY");

var _styles2 = _interopRequireDefault(_styles);

var _ramda = __webpack_require__("tpu8");

var _ramda2 = _interopRequireDefault(_ramda);

var _styles3 = __webpack_require__("nsQX");

var _styles4 = _interopRequireDefault(_styles3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getLocationString = function getLocationString(city, state, zip) {
	if (city && city.length && state && state.length && zip && zip.length) {
		return city + ', ' + state + ' ' + zip;
	}
	return undefined;
};

var getFoundedString = function getFoundedString(foundedYear) {
	return foundedYear ? 'Founded ' + foundedYear : undefined;
};

var getMemberSinceString = function getMemberSinceString(memberSinceYear) {
	return memberSinceYear && memberSinceYear.length ? 'Work Market member since ' + memberSinceYear.substr(-4) : undefined;
};

var getTeamMembersString = function getTeamMembersString(employeeCount) {
	return employeeCount ? employeeCount + ' Team Members' : undefined;
};

var getOverviewListItems = _ramda2.default.memoize(function (_ref) {
	var website = _ref.website,
	    _ref$location = _ref.location,
	    city = _ref$location.city,
	    state = _ref$location.state,
	    zip = _ref$location.zip,
	    yearFounded = _ref.yearFounded,
	    createdOn = _ref.createdOn,
	    employees = _ref.employees;
	return [{
		icon: 'important_devices',
		id: 'website',
		label: website
	}, {
		icon: 'place',
		id: 'location',
		label: getLocationString(city, state, zip)
	}, {
		icon: 'flag',
		id: 'founded',
		label: getFoundedString(yearFounded)
	}, {
		icon: 'loyalty',
		id: 'memberSince',
		label: getMemberSinceString(createdOn)
	}, {
		icon: 'people',
		id: 'employees',
		label: getTeamMembersString(employees)
	}];
});

var getCompanyTitle = _ramda2.default.memoize(function (name, followedByUser, followedByUserRequested, toggleFunc, blockFunc, blockedByUser, blockByUserRequested, isPublic) {
	return _react2.default.createElement(
		'div',
		null,
		_react2.default.createElement(
			_WMHeading2.default,
			{
				level: '3'
			},
			name,
			_react2.default.createElement(
				'div',
				{ style: _styles4.default.actionContainer },
				!isPublic && !blockedByUser && _react2.default.createElement(_WMRaisedButton2.default, {
					label: followedByUser ? 'Following' : 'Follow',
					backgroundColor: followedByUser ? _styles4.default.followButtonColors.following : _styles4.default.followButtonColors.follow,
					disabled: followedByUserRequested,
					labelColor: _styles4.default.followButtonLabel.color,
					style: _styles4.default.followButton,
					labelStyle: _styles4.default.followButtonLabel,
					onClick: toggleFunc,
					icon: followedByUser && _react2.default.createElement(
						_WMFontIcon2.default,
						{
							className: 'material-icons',
							id: 'wm-company-page__company-title'
						},
						'done'
					)
				}),
				_react2.default.createElement(_WMRaisedButton2.default, {
					label: blockedByUser ? 'Blocked' : 'Block Company',
					disabled: blockByUserRequested || blockedByUser,
					style: _styles4.default.blockButton,
					onClick: blockFunc
				})
			)
		),
		blockedByUser && _react2.default.createElement(
			'div',
			null,
			'You have blocked this company. ',
			_react2.default.createElement(
				'a',
				{ href: '/relationships/blocked_clients' },
				'Manage Blocked Clients'
			)
		)
	);
});

var WMCompanyPageOverview = function WMCompanyPageOverview(props) {
	var name = props.name,
	    overview = props.overview,
	    website = props.website,
	    location = props.location,
	    yearFounded = props.yearFounded,
	    createdOn = props.createdOn,
	    employees = props.employees,
	    followedByUser = props.followedByUser,
	    followedByUserRequested = props.followedByUserRequested,
	    toggleFollowCompany = props.toggleFollowCompany,
	    blockedByUser = props.blockedByUser,
	    blockByUserRequested = props.blockByUserRequested,
	    blockFunc = props.blockFunc,
	    isPublic = props.isPublic;

	var overviewListItems = getOverviewListItems({
		website: website,
		location: location,
		yearFounded: yearFounded,
		createdOn: createdOn,
		employees: employees
	});
	var hasAvatar = props.avatar && props.avatar.length;

	return _react2.default.createElement(
		_WMPaper2.default,
		{
			rounded: false,
			style: _styles4.default.container,
			zDepth: 2
		},
		_react2.default.createElement(
			'div',
			{
				'data-attr-id': 'wm-company-page__title-columns',
				style: _styles4.default.columns
			},
			_react2.default.createElement(
				'div',
				{
					'data-attr-id': 'wm-company-page__title-left',
					style: _styles4.default.getColumnStyle(hasAvatar ? 'left' : 'none')
				},
				hasAvatar ? _react2.default.createElement(
					'div',
					{
						style: _styles4.default.avatarContainer,
						'data-attr-id': 'wm-company-page__avatar-container'
					},
					_react2.default.createElement('img', {
						src: props.avatar,
						alt: 'Logo',
						style: _styles4.default.avatar,
						'data-attr-id': 'wm-company-page__avatar'
					})
				) : getCompanyTitle(name, followedByUser, followedByUserRequested, toggleFollowCompany, blockFunc, blockedByUser, blockByUserRequested, isPublic)
			),
			_react2.default.createElement(
				'div',
				{
					'data-attr-id': 'wm-company-page__title-right',
					style: _styles4.default.getColumnStyle('right')
				},
				hasAvatar && getCompanyTitle(name, followedByUser, followedByUserRequested, toggleFollowCompany, blockFunc, blockedByUser, blockByUserRequested)
			)
		),
		_react2.default.createElement(
			'div',
			{
				'data-attr-id': 'wm-company-page__overview-columns',
				style: _styles4.default.columns
			},
			_react2.default.createElement(
				'div',
				{
					'data-attr-id': 'wm-company-page__overview-left',
					style: _styles4.default.getColumnStyle('left')
				},
				overviewListItems.map(function (listItem) {
					if (listItem.label) {
						return _react2.default.createElement(
							'div',
							{
								className: 'wm-company-page__overview-item',
								'data-attr-id': 'wm-company-page__overview-' + listItem.id + '-item',
								key: listItem.id,
								style: _styles4.default.overviewItem
							},
							_react2.default.createElement(
								_WMFontIcon2.default,
								{
									className: 'material-icons',
									id: 'wm-company-page__overview-item-' + listItem.id + '-icon',
									'data-attr-id': 'wm-company-page__overview-item-' + listItem.id + '-icon',
									color: _styles2.default.colors.baseColors.grey,
									style: _styles4.default.overviewItemIcon
								},
								listItem.icon
							),
							_react2.default.createElement(
								_WMText2.default,
								{
									inline: true,
									style: _styles4.default.overviewItemLabel
								},
								listItem.label
							)
						);
					}
					return null;
				})
			),
			_react2.default.createElement(
				'div',
				{
					'data-attr-id': 'wm-company-page__overview-right',
					style: _styles4.default.getColumnStyle('right')
				},
				_react2.default.createElement(
					_WMText2.default,
					{
						style: _styles4.default.overviewText
					},
					overview
				)
			)
		)
	);
};

var _default = WMCompanyPageOverview;
exports.default = _default;


WMCompanyPageOverview.propTypes = {
	name: _propTypes.PropTypes.string,
	website: _propTypes.PropTypes.string,
	location: _propTypes.PropTypes.shape({
		city: _propTypes.PropTypes.string,
		state: _propTypes.PropTypes.string,
		zip: _propTypes.PropTypes.string
	}),
	yearFounded: _propTypes.PropTypes.number,
	createdOn: _propTypes.PropTypes.string,
	employees: _propTypes.PropTypes.number,
	overview: _propTypes.PropTypes.string,
	avatar: _propTypes.PropTypes.string,
	followedByUser: _propTypes.PropTypes.bool.isRequired,
	followedByUserRequested: _propTypes.PropTypes.bool.isRequired,
	toggleFollowCompany: _propTypes.PropTypes.func.isRequired,
	blockFunc: _propTypes.PropTypes.func.isRequired,
	blockedByUser: _propTypes.PropTypes.bool.isRequired,
	blockByUserRequested: _propTypes.PropTypes.bool.isRequired,
	isPublic: _propTypes.PropTypes.bool
};

WMCompanyPageOverview.defaultProps = {
	name: '',
	website: '',
	location: _propTypes.PropTypes.shape({
		city: '',
		state: '',
		zip: ''
	}),
	yearFounded: 0,
	createdOn: '',
	employees: 0,
	overview: '',
	avatar: '',
	isPublic: false
};
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(getLocationString, 'getLocationString', 'src/components/WMCompanyPageOverview/template.js');

	__REACT_HOT_LOADER__.register(getFoundedString, 'getFoundedString', 'src/components/WMCompanyPageOverview/template.js');

	__REACT_HOT_LOADER__.register(getMemberSinceString, 'getMemberSinceString', 'src/components/WMCompanyPageOverview/template.js');

	__REACT_HOT_LOADER__.register(getTeamMembersString, 'getTeamMembersString', 'src/components/WMCompanyPageOverview/template.js');

	__REACT_HOT_LOADER__.register(getOverviewListItems, 'getOverviewListItems', 'src/components/WMCompanyPageOverview/template.js');

	__REACT_HOT_LOADER__.register(getCompanyTitle, 'getCompanyTitle', 'src/components/WMCompanyPageOverview/template.js');

	__REACT_HOT_LOADER__.register(WMCompanyPageOverview, 'WMCompanyPageOverview', 'src/components/WMCompanyPageOverview/template.js');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/WMCompanyPageOverview/template.js');
}();

;

/***/ })

});


// WEBPACK FOOTER //
// invitationlandingpage_vendor.js